import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detail-suppier',
  templateUrl: './detail-suppier.component.html',
  styleUrls: ['./detail-suppier.component.scss']
})
export class DetailSuppierComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
